import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef } from 'react';
import PropTypes from 'prop-types';
import { StyledMenuItem, Anchor, SelectedBar } from './SideNavigationMenuItem.styles.js';
import { VARIANTS, Icon } from '../../Icon/Icon.js';
import { usePositionOffset } from './usePositionOffset.js';
import { SideNavigationSubMenu } from '../SideNavigationSubMenu/SideNavigationSubMenu.js';
import { SideNavigationMenuItemText } from './SideNavigationMenuItemText.js';
import { useSideNavigationKeyboardContext } from '../SideNavigationContexts/SideNavigationKeyboardContext.js';
import { useSideNavigationThemeContext } from '../SideNavigationContexts/SideNavigationThemeContext.js';

var SideNavigationMenuItem = function SideNavigationMenuItem(_ref) {
  var children = _ref.children,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'a' : _ref$component,
    _ref$componentProps = _ref.componentProps,
    componentProps = _ref$componentProps === void 0 ? {} : _ref$componentProps,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? VARIANTS[0] : _ref$icon,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    _ref$isSubmenuOpen = _ref.isSubmenuOpen,
    isSubmenuOpen = _ref$isSubmenuOpen === void 0 ? false : _ref$isSubmenuOpen,
    _ref$menuItemId = _ref.menuItemId,
    menuItemId = _ref$menuItemId === void 0 ? undefined : _ref$menuItemId,
    _ref$selectedSubmenu = _ref.selectedSubmenu,
    selectedSubmenu = _ref$selectedSubmenu === void 0 ? undefined : _ref$selectedSubmenu,
    _ref$onKeyUp = _ref.onKeyUp,
    onKeyUp = _ref$onKeyUp === void 0 ? undefined : _ref$onKeyUp,
    _ref$onKeyDown = _ref.onKeyDown,
    onKeyDown = _ref$onKeyDown === void 0 ? undefined : _ref$onKeyDown,
    _ref$subMenu = _ref.subMenu,
    subMenu = _ref$subMenu === void 0 ? undefined : _ref$subMenu,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var _usePositionOffset = usePositionOffset(),
    anchorRef = _usePositionOffset.anchorRef,
    calculateTopOffset = _usePositionOffset.calculateTopOffset,
    floatingRef = _usePositionOffset.floatingRef,
    offsetTopPosition = _usePositionOffset.offsetTopPosition;
  var _useSideNavigationThe = useSideNavigationThemeContext(),
    isTouch = _useSideNavigationThe.isTouch;
  var displayIcon = isTouch && isSubmenuOpen ? 'ChevronLeft' : icon;
  var onMouseEnter = function onMouseEnter() {
    if (subMenu) calculateTopOffset();
  };
  var sideNavigationMenuItemRef = useRef(null);
  var _useSideNavigationKey = useSideNavigationKeyboardContext(),
    setFocusRef = _useSideNavigationKey.setFocusRef;
  var handleOnFocus = function handleOnFocus() {
    if (sideNavigationMenuItemRef.current) {
      setFocusRef(sideNavigationMenuItemRef.current);
    }
    if (subMenu) calculateTopOffset();
  };
  return React__default.createElement(StyledMenuItem, {
    "data-testid": testId,
    ref: anchorRef,
    $isTouch: isTouch,
    $menuItemId: menuItemId,
    $selectedSubmenu: selectedSubmenu,
    $subMenuOffsetTop: offsetTopPosition
  }, React__default.createElement(Anchor, _extends({
    as: component
  }, componentProps, {
    tabIndex: "0",
    ref: sideNavigationMenuItemRef,
    onFocus: handleOnFocus,
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    $isTouch: isTouch,
    $isSelected: isSelected,
    $isSubmenuOpen: isSubmenuOpen
  }), isSelected && !isSubmenuOpen && React__default.createElement(SelectedBar, {
    "data-testid": "active-indicator"
  }), React__default.createElement("div", null, React__default.createElement(Icon, {
    size: "regular",
    variant: displayIcon
  })), React__default.createElement(SideNavigationMenuItemText, {
    isTitle: isSubmenuOpen && isTouch,
    as: "p",
    title: children
  }, children)), subMenu && React__default.createElement(SideNavigationSubMenu, {
    ref: floatingRef,
    isSelected: isSubmenuOpen,
    isSubmenuOpen: isSubmenuOpen,
    topOffset: offsetTopPosition
  }, subMenu));
};
SideNavigationMenuItem.propTypes = {
  children: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  componentProps: PropTypes.object,
  icon: PropTypes.oneOf(VARIANTS),
  isSelected: PropTypes.bool,
  isSubmenuOpen: PropTypes.bool,
  menuItemId: PropTypes.string,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  selectedSubmenu: PropTypes.string,
  subMenu: PropTypes.node,
  testId: PropTypes.string
};

export { SideNavigationMenuItem, SideNavigationMenuItem as default };
//# sourceMappingURL=SideNavigationMenuItem.js.map
